<template>
  <v-layout style="z-index: 0;">
    <v-breadcrumbs class="breadcrumbs" :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
  </v-layout>
</template>

<script setup>
import { computed, watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import Config from "@/config";

const route = useRoute();

const title = ref(route.meta.title);

watch(
  () => route.meta.title,
  (newTitle) => {
    title.value = newTitle;
  },
);

const breadcrumbs = computed(() => {
  const rootRedirect = Config.isGuest() ? route.guestRedirect : route.redirect;
  const matched = route.matched;
  let id = route.params.id;

  return matched.map((route, index) => {
    let href =
      index === matched.length - 1
        ? `#${route.path}`
        : `#${route.path}` || `#${rootRedirect}`;
    href = href.replace(/:id/g, id);
    const title = route.meta.title;

    return {
      title,
      href,
      disabled: false,
    };
  });
});
</script>

<style lang="scss" scoped>
.breadcrumbs {
  padding-bottom: 0;
}
</style>